











































































































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import ItemTile from '@/components/ItemTile.vue'
import AppEmptyCard from '@/components/AppEmptyCard.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTabBar from '@/components/AppTabBar.vue'
import AppTagBar from '@/components/AppTagBar.vue'
import AppTile from '@/components/AppTile.vue'
import FilterModal from '@/components/FilterModal.vue'

import { Common, ScrollToFetch } from '@/mixins'
import { FEED_TILE_FRAGMENT } from '@/gql/feed'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { ScrollQuery } from '@/mixins/scroll-to-fetch'

@Component({
  components: {
    ItemTile,
    AppEmptyCard,
    AppRouterLink,
    AppTabBar,
    AppTagBar,
    AppTile,
    FilterModal
  },
  apollo: {
    recommendedTags: {
      query: gql`query {
        recommendedTags
      }`,
      skip () {
        return !this.$route.query.withTags
      }
    },
    viewSection: {
      query: gql`query viewSection($id: ID!) {
        viewSection(id: $id) @client {
          id
          data {
            feeds {
              ...FeedTileFragment
            }
          }
        }
      }
      ${FEED_TILE_FRAGMENT}`,
      variables () {
        return {
          id: this.$route.query.viewSectionId
        }
      },
      skip () {
        return !this.$route.query.viewSectionId
      }
    },
    allFeedConnection: {
      query: gql`query ($after: String) {
        allFeedConnection(after: $after) {
          cursor
          hasNextPage
          feeds {
            ...FeedTileFragment
          }
        }
      }
      ${FEED_TILE_FRAGMENT}`,
      skip () {
        return this.$route.query.tab !== 'FEED' || this.$route.query.term !== '전체'
      }
    },
    searchFeed: {
      query () {
        return gql`query searchFeed($query: String!, $filter: String, $first: Int, $after: String) {
          searchFeed(query: $query, filter: $filter, first: $first, after: $after) {
            suggestedFilters
            usedFilter
            searchedFeedConnection {
              cursor
              hasNextPage
              feeds {
                ...FeedTileFragment
              }
            }
          }
        }
        ${FEED_TILE_FRAGMENT}`
      },
      variables () {
        return {
          query: this.$route.query.term
        }
      },
      skip () {
        return this.$route.query.tab !== 'FEED' || this.$route.query.term === '전체'
      }
    },
    searchItem: {
      query () {
        return gql`query ($query: String!, $sellerId: ID, $options: AdvancedSearchOptionInput,
          $first: Int, $after: String) {
          searchItem(query: $query, sellerId: $sellerId, options: $options, first: $first, after: $after) {
            suggestedFilters
            usedFilter
            minPrice
            maxPrice
            isEmpty
            tags {
              id
              name
              type
              medias {
                id
                path
              }
            }
            searchedItemConnection {
              cursor
              hasNextPage
              items {
                ...ItemTileFragment
              }
            }
          }
        }
        ${ITEM_TILE_FRAGMENT}`
      },
      variables () {
        return {
          query: this.$route.query.term,
          sellerId: this.$route.query.sellerId,
          options: {
            categories: this.$route.query.categories || [],
            colors: this.$route.query.colors || [],
            excludeSoldOuts: this.booleanQueryValue('excludeSoldOuts', true),
            showOnlyDiscountedItems: this.booleanQueryValue('showOnlyDiscountedItems', false),
            showOnlyTimeSaleItems: this.booleanQueryValue('showOnlyTimeSaleItems', false),
            showPepperOnlyItems: this.booleanQueryValue('showPepperOnlyItems'),
            showOnlyPaybackItems: this.booleanQueryValue('showOnlyPaybackItems'),
            sortSpec: this.$route.query.sortSpec || 'CREATED_AT_DESC',
            minPrice: +this.$route.query.minPrice || undefined,
            maxPrice: +this.$route.query.maxPrice || undefined
          }
        }
      },
      skip () {
        return this.$route.query.tab !== 'ITEM'
      }
    },
    searchUser: {
      query () {
        return gql`query searchUser($query: String!, $first: Int, $after: String) {
          searchUser(query: $query, first: $first, after: $after) {
            cursor
            hasNextPage
            users {
              id
              username
              displayName
              media {
                id
                path
              }
              shop {
                id
                status
              }
            }
          }
        }`
      },
      variables () {
        return {
          query: this.$route.query.term
        }
      },
      skip () {
        return this.$route.query.tab !== 'USER'
      }
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  recommendedTags = []
  viewSection = { data: { feeds: [] } }
  isFilterModalActive = false
  allFeedConnection = { cursor: null, hasNextPage: false, feeds: [] }
  searchFeed: {
    searchedFeedConnection: {
      cursor: string|null;
      hasNextPage: boolean;
      feeds: object[];
    };
  } = {
    searchedFeedConnection: {
      cursor: null,
      hasNextPage: false,
      feeds: []
    }
  }

  searchItem: {
    suggestedFilters: string[];
    searchedItemConnection: {
      cursor: string|null;
      hasNextPage: boolean;
      items: object[];
    };
    tags: object[];
  } = {
    suggestedFilters: [],
    searchedItemConnection: {
      cursor: null,
      hasNextPage: false,
      items: []
    },
    tags: []
  }

  searchUser: {
    cursor: string|null;
    hasNextPage: boolean;
    users: { shop?: { status: string } }[];
  } = {
    cursor: null,
    hasNextPage: false,
    users: []
  }

  now = Math.floor(Date.now() / 1000)
  intervalId!: NodeJS.Timeout

  async appSearchClick (engine: string, documentId: string) {
    await this.$apollo.mutate({
      mutation: gql`mutation appSearchClick($input: AppSearchClickInput!) {
        appSearchClick(input: $input) {
          success
        }
      }`,
      variables: {
        input: {
          engine,
          query: this.$route.query.term,
          documentId
        }
      }
    })
  }

  get isAllFeed () {
    return this.$route.query.tab === 'FEED' && this.$route.query.term === '전체'
  }

  get feeds () {
    return this.isAllFeed ? this.allFeedConnection.feeds : this.searchFeed.searchedFeedConnection.feeds
  }

  get users () {
    return this.searchUser.users.filter(user => !user.shop || user.shop.status === 'ACTIVE')
  }

  get isEmptyResult () {
    if (this.$apollo.loading) return false

    return (this.$route.query.tab === 'FEED' && !this.feeds.length) ||
      (this.$route.query.tab === 'ITEM' && !this.searchItem.searchedItemConnection.items.length) ||
      (this.$route.query.tab === 'USER' && !this.users.length)
  }

  mounted () {
    this.intervalId = setInterval(() => {
      console.log('Search setInterval')
      this.now = Math.floor(Date.now() / 1000)
    }, 1000)

    const scrolledQueries: { [key: string]: ScrollQuery } = {
      FEED: {
        name: 'searchFeed',
        connection: () => this.searchFeed.searchedFeedConnection,
        variables: () => ({ query: this.$route.query.term }),
        updateQuery: (
          prevResult: { searchFeed: {searchedFeedConnection: { feeds: object[] } } },
          fetchMoreResult: { searchFeed: {searchedFeedConnection: { feeds: object[] } } }
        ) => ({
          searchFeed: {
            ...fetchMoreResult.searchFeed,
            searchedFeedConnection: {
              ...fetchMoreResult.searchFeed.searchedFeedConnection,
              feeds: [
                ...prevResult.searchFeed.searchedFeedConnection.feeds,
                ...fetchMoreResult.searchFeed.searchedFeedConnection.feeds
              ]
            }
          }
        })
      },
      ITEM: {
        name: 'searchItem',
        connection: () => this.searchItem.searchedItemConnection,
        variables: () => ({
          query: this.$route.query.term,
          options: {
            categories: this.$route.query.categories || [],
            colors: this.$route.query.colors || [],
            excludeSoldOuts: this.booleanQueryValue('excludeSoldOuts', true),
            showOnlyDiscountedItems: this.booleanQueryValue('showOnlyDiscountedItems', false),
            showOnlyTimeSaleItems: this.booleanQueryValue('showOnlyTimeSaleItems', false),
            showPepperOnlyItems: this.booleanQueryValue('showPepperOnlyItems'),
            showOnlyPaybackItems: this.booleanQueryValue('showOnlyPaybackItems'),
            sortSpec: this.$route.query.sortSpec || 'CREATED_AT_DESC',
            minPrice: +this.$route.query.minPrice || undefined,
            maxPrice: +this.$route.query.maxPrice || undefined
          }
        }),
        updateQuery: (
          prevResult: { searchItem: {searchedItemConnection: { items: object[] } } },
          fetchMoreResult: { searchItem: {searchedItemConnection: { items: object[] } } }
        ) => ({
          searchItem: {
            ...fetchMoreResult.searchItem,
            searchedItemConnection: {
              ...fetchMoreResult.searchItem.searchedItemConnection,
              items: [
                ...prevResult.searchItem.searchedItemConnection.items,
                ...fetchMoreResult.searchItem.searchedItemConnection.items
              ]
            }
          }
        })
      },
      USER: {
        name: 'searchUser',
        connection: () => this.searchUser,
        variables: () => ({ query: this.$route.query.term }),
        updateQuery: (prevResult, fetchMoreResult) => ({
          ...fetchMoreResult,
          searchUser: {
            ...fetchMoreResult.searchUser,
            users: [
              ...prevResult.searchUser.users,
              ...fetchMoreResult.searchUser.users
            ]
          }
        })
      },
      ALL_FEED: {
        name: 'allFeedConnection',
        connection: () => this.allFeedConnection,
        variables: () => ({}),
        updateQuery: (prevResult, fetchMoreResult) => ({
          ...fetchMoreResult,
          allFeedConnection: {
            ...fetchMoreResult.allFeedConnection,
            feeds: [
              ...prevResult.allFeedConnection.feeds,
              ...fetchMoreResult.allFeedConnection.feeds
            ]
          }
        })
      }
    }

    this.addScrollListenerWithMultipleQueries(scrolledQueries, () => this.isAllFeed ? 'ALL_FEED' : this.$route.query.tab as string)
  }

  beforeDestroy () {
    clearInterval(this.intervalId)
  }

  get tabs () {
    const tabs = [
      { id: 'FEED', name: '스토리' },
      { id: 'ITEM', name: '아이템' }
    ]
    if (!this.$route.query.hideUser) {
      tabs.push({ id: 'USER', name: '유저' })
    }
    return tabs
  }

  get currentCategories () {
    if (this.$route.query.tab !== 'ITEM') {
      return undefined
    }

    return [
      { id: '', name: '전체' },
      ...this.searchItem.suggestedFilters.map(filter => ({ id: filter, name: filter }))
    ]
  }

  get isFilterEnabled () {
    return !!(this.currentCategories /* && this.searchItem.tags.length */)
  }

  async onSelectTag (term: string) {
    await this.routerPush({ path: '/search', query: { ...this.$route.query, term } })
  }
}
